import {create} from "zustand";

export const useAppInstallModal = create((set) => ({
    isOpen: false,
    text: null,
    openModal: (text) => set({ isOpen: true, text }),
    closeModal: () => set({ isOpen: false, text: null }),
}));
